import moment from 'moment'
import { stringify } from 'query-string'
import fileDownload from 'js-file-download'

import { createXlsxData } from '../utils'
import { getApiUrl } from '../../../../../../apiService'
import { fetchWithAuthorization } from '../../../../../../lib/api'
import {
  toastNotifyDownloadNlpLogsError,
  toastNotifyDownloadNlpLogsInfo,
  toastNotifyDownloadNlpLogsSuccess
} from './toasts'

export async function downloadNlpLogs(
  botId: string,
  fromTimestamp: number,
  toTimestamp: number,
  setIsFileDownloading: (value: boolean) => void
): Promise<void> {
  setIsFileDownloading(true)
  const query = stringify({ fromTimestamp, toTimestamp })
  try {
    const logs = await fetchWithAuthorization(getApiUrl(`/bots/${botId}/export/nlpLog?${query}`), {
      method: 'GET',
      checkOk: true
    })

    if (!logs?.length) {
      setIsFileDownloading(false)
      toastNotifyDownloadNlpLogsInfo()
      return
    }

    const data = createXlsxData('Nlp logs', logs)
    fileDownload(data, `${botId}-${moment().format('YYYY-MM-DD')}.xlsx`)

    setIsFileDownloading(false)
    toastNotifyDownloadNlpLogsSuccess(logs.length)
  } catch (error) {
    console.error((error as Error)?.message)
    setIsFileDownloading(false)
    toastNotifyDownloadNlpLogsError()
  }
}
